import { ModalStatus } from "typings";

export const modalContext: {
  stack: ModalStatus[];
  index: number;
  url: string;
  scrollY: number;
} = { stack: [], index: -1, url: "", scrollY: 0 };
